module.exports = __webpack_public_path__ + "img/370-b7cac9.png";